<div class="sc-scorecard-grid">
    <div
        class="my-3 mx-auto text-center"
        *ngIf="!model?.rows || model?.rows.length === 0"
    >
        {{ _i18n._711_NO_DATA_AVAILABLE | translate }}
    </div>
    <div class="gridContainer">
        <div
            ngGrid
            [rendererOptions]="_rendererOpts"
            [selectTemplate]="_selectTpl"
            [rows]="model?.rows"
            [sortDefs]="model?.sortDefs"
            (willInflate)="_onWillInflate()"
            (didInflate)="_onDidInflate()"
            *ngIf="model?.rows?.length !== 0"
        >
            <ng-template
                gridContent
                data-type="grid"
            >
                <div></div>
            </ng-template>
            <ng-template
                gridContent
                data-type="row"
            >
                <div></div>
            </ng-template>
            <ng-template
                let-c="c"
                let-ctx="ctx"
                let-expanded="expanded"
                #sortTpl
            >
                <button
                    class="align-self-start"
                    (click)="_onSortClick(c)"
                >
                    <cmps-icon
                        [class.cmps-cdk-fill-white]="!expanded"
                        [class.cmps-cdk-fill-black]="expanded"
                        [svgIcon]="
                            model?.sortDefs[0].order === _SortOrder.ASC
                                ? 'chevron-up'
                                : 'chevron-down'
                        "
                        *ngIf="
                            model?.sortDefs &&
                            model?.sortDefs.length &&
                            model?.sortDefs[0].columnId === c.id &&
                            (model?.sortDefs[0].columnType).toString() ===
                                ctx.type.toString()
                        "
                    ></cmps-icon>
                    <cmps-icon
                        [class.cmps-cdk-fill-white]="!expanded"
                        [class.cmps-cdk-fill-black]="expanded"
                        svgIcon="unfold-more-horizontal"
                        *ngIf="
                            !model?.sortDefs ||
                            !model?.sortDefs.length ||
                            model?.sortDefs[0].columnId !== c.id ||
                            (model?.sortDefs[0].columnType).toString() !==
                                ctx.type.toString()
                        "
                    ></cmps-icon>
                </button>
            </ng-template>
            <ng-template
                gridContent
                data-type="cell"
                data-id="headerGroup"
                let-c="c"
                let-ctx="ctx"
            >
                <div
                    [ngSwitch]="ctx.type"
                    class="justify-content-center align-items-center flex-wrap"
                >
                    <div class="sc-grid-table-header-content-group-pillar">
                        <span>{{ c.ctx.pillarName | translate }}</span>
                    </div>
                </div>
            </ng-template>
            <ng-template
                gridContent
                data-type="cell"
                data-id="header"
                let-c="c"
                let-ctx="ctx"
            >
                <div [ngSwitch]="ctx.metricId">
                    <div
                        class="sc-grid-table-header"
                        *ngSwitchCase="_ColumnType.SUPERGROUP_NAME"
                        [ngStyle]="{ 'background-color': headerColour }"
                    >
                        <span (click)="_onSortClick(c)">{{
                            c.ctx.metricName | translate
                        }}</span>
                        <div class="sc-grid-table-header-sorting-icon">
                            <ng-container
                                *ngTemplateOutlet="
                                    sortTpl;
                                    context: { c: c, ctx: ctx }
                                "
                            ></ng-container>
                        </div>
                    </div>

                    <div
                        class="sc-grid-table-header"
                        *ngSwitchCase="_ColumnType.USER_NAME"
                        [ngStyle]="{ 'background-color': headerColour }"
                    >
                        <span (click)="_onSortClick(c)">{{
                            c.ctx.metricName | translate
                        }}</span>
                        <div class="sc-grid-table-header-sorting-icon">
                            <ng-container
                                *ngTemplateOutlet="
                                    sortTpl;
                                    context: { c: c, ctx: ctx }
                                "
                            ></ng-container>
                        </div>
                    </div>

                    <div
                        class="sc-grid-table-header"
                        *ngSwitchCase="_ColumnType.PERIOD"
                        [ngStyle]="{ 'background-color': headerColour }"
                    >
                        <span (click)="_onSortClick(c)">{{
                            c.ctx.metricName | translate
                        }}</span>
                        <div class="sc-grid-table-header-sorting-icon">
                            <ng-container
                                *ngTemplateOutlet="
                                    sortTpl;
                                    context: { c: c, ctx: ctx }
                                "
                            ></ng-container>
                        </div>
                    </div>
                    <div
                        class="sc-grid-table-header"
                        *ngSwitchCase="_ColumnType.OVERALL_SCORE"
                        [ngStyle]="{ 'background-color': headerColour }"
                    >
                        <span (click)="_onSortClick(c)">{{
                            c.ctx.metricName | translate
                        }}</span>
                        <div class="sc-grid-table-header-sorting-icon">
                            <ng-container
                                *ngTemplateOutlet="
                                    sortTpl;
                                    context: { c: c, ctx: ctx }
                                "
                            ></ng-container>
                        </div>
                    </div>

                    <div
                        class="sc-grid-table-header sc-grid-table-header-default"
                        [hidden]="c.hidden"
                        *ngSwitchCase="_ColumnType.TARGET"
                    >
                        <span (click)="_onSortClick(c)">
                            {{ _i18n._726_TARGET | translate }}
                        </span>
                        <div
                            class="sc-grid-table-header-sorting-icon sc-grid-table-header-sorting-icon-expanded"
                        >
                            <ng-container
                                *ngTemplateOutlet="
                                    sortTpl;
                                    context: { c: c, ctx: ctx, expanded: true }
                                "
                            ></ng-container>
                        </div>
                    </div>

                    <div
                        class="sc-grid-table-header sc-grid-table-header-default"
                        [hidden]="c.hidden"
                        *ngSwitchCase="_ColumnType.TARGET_PERCENT"
                    >
                        <span (click)="_onSortClick(c)">
                            {{ _i18n._768___TO_TARGET | translate }}
                        </span>
                        <div
                            class="sc-grid-table-header-sorting-icon sc-grid-table-header-sorting-icon-expanded"
                        >
                            <ng-container
                                *ngTemplateOutlet="
                                    sortTpl;
                                    context: { c: c, ctx: ctx, expanded: true }
                                "
                            ></ng-container>
                        </div>
                    </div>

                    <div
                        class="sc-grid-table-header sc-grid-table-header-default"
                        [hidden]="c.hidden"
                        *ngSwitchCase="_ColumnType.POINTS_BAND"
                    >
                        <span (click)="_onSortClick(c)">
                            {{ _i18n._9261_POINTS_BAND | translate }}
                        </span>
                        <div
                            class="sc-grid-table-header-sorting-icon sc-grid-table-header-sorting-icon-expanded"
                        >
                            <ng-container
                                *ngTemplateOutlet="
                                    sortTpl;
                                    context: { c: c, ctx: ctx, expanded: true }
                                "
                            ></ng-container>
                        </div>
                    </div>

                    <div
                        class="sc-grid-table-header sc-grid-table-header-default"
                        [hidden]="c.hidden"
                        *ngSwitchCase="_ColumnType.WEIGHT"
                    >
                        <span (click)="_onSortClick(c)">
                            {{ _i18n._9256_WEIGHT | translate }}
                        </span>
                        <div
                            class="sc-grid-table-header-sorting-icon sc-grid-table-header-sorting-icon-expanded"
                        >
                            <ng-container
                                *ngTemplateOutlet="
                                    sortTpl;
                                    context: { c: c, ctx: ctx, expanded: true }
                                "
                            ></ng-container>
                        </div>
                    </div>

                    <div
                        class="sc-grid-table-header sc-grid-table-header-default"
                        [hidden]="c.hidden"
                        *ngSwitchCase="_ColumnType.ADJUSTED_POINTS"
                    >
                        <span (click)="_onSortClick(c)">
                            {{ _i18n._9258_ADJUSTED_POINTS | translate }}
                        </span>
                        <div
                            class="sc-grid-table-header-sorting-icon sc-grid-table-header-sorting-icon-expanded"
                        >
                            <ng-container
                                *ngTemplateOutlet="
                                    sortTpl;
                                    context: { c: c, ctx: ctx, expanded: true }
                                "
                            ></ng-container>
                        </div>
                    </div>

                    <div
                        class="sc-grid-table-header sc-grid-table-header-default"
                        [hidden]="c.hidden"
                        *ngSwitchCase="_ColumnType.ISINEFFECT"
                    >
                        <span (click)="_onSortClick(c)">
                            {{ _i18n._9303_COMPENSATION_IN_EFFECT | translate }}
                        </span>
                        <div
                            class="sc-grid-table-header-sorting-icon sc-grid-table-header-sorting-icon-expanded"
                        >
                            <ng-container
                                *ngTemplateOutlet="
                                    sortTpl;
                                    context: { c: c, ctx: ctx, expanded: true }
                                "
                            ></ng-container>
                        </div>
                    </div>

                    <div
                        class="sc-grid-table-header sc-grid-table-header-default"
                        [hidden]="c.hidden"
                        *ngSwitchCase="_ColumnType.QUALIFIERMET"
                    >
                        <span (click)="_onSortClick(c)">
                            {{
                                _i18n._9304_COMPENSATION_QUALIFIER_MET
                                    | translate
                            }}
                        </span>
                        <div
                            class="sc-grid-table-header-sorting-icon sc-grid-table-header-sorting-icon-expanded"
                        >
                            <ng-container
                                *ngTemplateOutlet="
                                    sortTpl;
                                    context: { c: c, ctx: ctx, expanded: true }
                                "
                            ></ng-container>
                        </div>
                    </div>

                    <div
                        class="sc-grid-table-header sc-grid-table-header-default"
                        [hidden]="c.hidden"
                        *ngSwitchCase="_ColumnType.RANK"
                    >
                        <span (click)="_onSortClick(c)">
                            {{ _i18n._9260_METRIC_RANK | translate }}
                        </span>
                        <div
                            class="sc-grid-table-header-sorting-icon sc-grid-table-header-sorting-icon-expanded"
                        >
                            <ng-container
                                *ngTemplateOutlet="
                                    sortTpl;
                                    context: { c: c, ctx: ctx, expanded: true }
                                "
                            ></ng-container>
                        </div>
                    </div>

                    <div
                        class="sc-grid-table-header"
                        [hidden]="c.hidden"
                        *ngSwitchDefault
                        [ngStyle]="{ 'background-color': headerColour }"
                    >
                        <span (click)="_onSortClick(c)">{{
                            ctx.metricName
                        }}</span>
                        <div class="sc-grid-table-header-sorting-icon">
                            <ng-container
                                *ngTemplateOutlet="
                                    sortTpl;
                                    context: { c: c, ctx: ctx }
                                "
                            ></ng-container>
                            <button
                                class="align-self-end"
                                (click)="_onExpandClick($event, c)"
                            >
                                <cmps-icon
                                    class="cmps-cdk-fill-white"
                                    [svgIcon]="
                                        c.ctx.isColumnExpanded
                                            ? 'arrow-collapse'
                                            : 'arrow-expand'
                                    "
                                ></cmps-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template
                gridContent
                data-type="cell"
                data-id="content"
                let-c="c"
                let-ctx="ctx"
                let-index="indx"
            >
                <div [ngSwitch]="c.ctx.metricId">
                    <div
                        class="sc-grid-table-content-pillar"
                        *ngSwitchCase="_ColumnType.USER_NAME"
                    >
                        <div class="directReportCell">
                            <span>{{ ctx?.data[0].directReport }}</span>
                            <cmps-icon
                                class="cell-icon"
                                svgIcon="open-in-new"
                                (click)="_onDRScorecardSelect(ctx?.data[0])"
                                [cmpsTooltipTrigger]="
                                    _i18n._9980_LAUNCH_SCORECARD | translate
                                "
                                trigger="hover"
                            ></cmps-icon>
                        </div>
                    </div>
                    <div
                        class="sc-grid-table-content"
                        *ngSwitchCase="_ColumnType.SUPERGROUP_NAME"
                    >
                        <span>{{ ctx?.data[0].superGroup }}</span>
                    </div>
                    <div
                        class="sc-grid-table-content"
                        *ngSwitchCase="_ColumnType.PERIOD"
                    >
                        <span>{{
                            (ctx.data[0]?.period | cmpsGridPeriod) || '-'
                        }}</span>
                    </div>
                    <div
                        class="sc-grid-table-content"
                        *ngSwitchCase="_ColumnType.OVERALL_SCORE"
                    >
                        <span>{{
                            ctx?.data[0].overallScore == null
                                ? '-'
                                : (ctx?.data[0].overallScore | number: '1.2-2')
                        }}</span>
                    </div>
                    <div
                        class="sc-grid-table-content"
                        *ngSwitchCase="_ColumnType.TARGET"
                    >
                        <span>{{
                            _retrieveExpandedCellData(
                                ctx?.data,
                                c.ctx.type,
                                c.ctx.metricId,
                                'target'
                            )
                        }}</span>
                    </div>
                    <div
                        class="sc-grid-table-content"
                        *ngSwitchCase="_ColumnType.TARGET_PERCENT"
                    >
                        <span>{{
                            _retrieveExpandedCellData(
                                ctx?.data,
                                c.ctx.type,
                                c.ctx.metricId,
                                'percentToTarget'
                            )
                        }}</span>
                    </div>
                    <div
                        class="sc-grid-table-content"
                        *ngSwitchCase="_ColumnType.POINTS_BAND"
                    >
                        <span>{{
                            _retrieveExpandedCellData(
                                ctx?.data,
                                c.ctx.type,
                                c.ctx.metricId,
                                'pointBand'
                            )
                        }}</span>
                    </div>
                    <div
                        class="sc-grid-table-content"
                        *ngSwitchCase="_ColumnType.WEIGHT"
                    >
                        <span>{{
                            _retrieveExpandedCellData(
                                ctx?.data,
                                c.ctx.type,
                                c.ctx.metricId,
                                'weight'
                            )
                        }}</span>
                    </div>
                    <div
                        class="sc-grid-table-content"
                        *ngSwitchCase="_ColumnType.ADJUSTED_POINTS"
                    >
                        <span>{{
                            _retrieveExpandedCellData(
                                ctx?.data,
                                c.ctx.type,
                                c.ctx.metricId,
                                'adjustedPoints'
                            )
                        }}</span>
                    </div>
                    <div
                        class="sc-grid-table-content"
                        *ngSwitchCase="_ColumnType.ISINEFFECT"
                    >
                        <span>{{
                            _retrieveExpandedCellData(
                                ctx?.data,
                                c.ctx.type,
                                c.ctx.metricId,
                                'isInEffect'
                            )
                        }}</span>
                    </div>
                    <div
                        class="sc-grid-table-content"
                        *ngSwitchCase="_ColumnType.QUALIFIERMET"
                    >
                        <span>{{
                            _retrieveExpandedCellData(
                                ctx?.data,
                                c.ctx.type,
                                c.ctx.metricId,
                                'isInEffect'
                            )
                        }}</span>
                    </div>
                    <div
                        class="sc-grid-table-content"
                        *ngSwitchCase="_ColumnType.RANK"
                    >
                        <span>{{
                            _retrieveExpandedCellData(
                                ctx?.data,
                                c.ctx.type,
                                c.ctx.metricId,
                                'rank'
                            )
                        }}</span>
                    </div>
                    <div
                        class="sc-grid-table-content"
                        *ngSwitchDefault
                    >
                        <span>{{
                            _retrieveCellValue(
                                ctx?.data,
                                c.ctx.type,
                                c.ctx.metricId,
                                'actual'
                            )
                        }}</span>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</div>
